export interface RenewalFormState {
  contractId: number;
  correlationId: string;
  equipmentId: string;
  managementAct: string;
  minorsOffers: Record<string, boolean>;
  paymentMeanId: string | null;
  personId: number;
  phoneNumber: string;
  saleDeviceId: string | null;
  selectedOffer: string | null;
  selectedOperator: string | null;
  token: string;
  amount: number | null;
  currency: string | null;
}

const defaultState: RenewalFormState = {
  contractId: 0,
  correlationId: '',
  equipmentId: '',
  managementAct: '',
  minorsOffers: {},
  paymentMeanId: null,
  personId: 0,
  phoneNumber: '',
  saleDeviceId: null,
  selectedOffer: null,
  selectedOperator: null,
  token: '',
  amount: null,
  currency: null
};

interface UpdateRenewalFormAction {
  type: 'UPDATE_RENEWAL_FORM';
  payload: {
    contractId: number;
    equipmentId: string;
    managementAct: string;
    minorsOffers: Record<string, boolean>;
    paymentMeanId: string;
    personId: number;
    phoneNumber: string;
    saleDeviceId: string | null;
    selectedOffer: string;
    selectedOperator: string;
  };
}

type AddHeadersToStoreAction = {
  type: 'ADD_HEADERS_TO_STORE';
  payload: {
    token: string;
    correlationId: string;
  };
};

type AddAmountAndCurrencyAction = {
  type: 'ADD_AMOUNT_AND_CURRENCY';
  payload: {
    amount: number;
    currency: string;
  };
};

type Actions =
  | AddHeadersToStoreAction
  | UpdateRenewalFormAction
  | AddAmountAndCurrencyAction;

export default function renewalForm(state = defaultState, action: Actions) {
  switch (action.type) {
    case 'UPDATE_RENEWAL_FORM':
      return {
        ...state,
        ...action.payload
      };

    case 'ADD_HEADERS_TO_STORE':
      return {
        ...state,
        token: action.payload.token,
        correlationId: action.payload.correlationId
      };

    case 'ADD_AMOUNT_AND_CURRENCY':
      return {
        ...state,
        amount: action.payload.amount,
        currency: action.payload.currency
      };
    default:
      return state;
  }
}

export const ADD_HEADERS_TO_STORE = 'ADD_HEADERS_TO_STORE';
export const UPDATE_RENEWAL_FORM = 'UPDATE_RENEWAL_FORM';
export const ADD_AMOUNT_AND_CURRENCY = 'ADD_AMOUNT_AND_CURRENCY';
